import { forEach, some } from "lodash";

import { CommunicationInterfaceType } from "./CommunicationInterfaceType";
import { CredentialsType } from "./CredentialsType";
import type { ISiteEquipmentWithCoverages } from "./ISiteEquipmentWithCoverages";
import { EquipmentTypeFunctions } from "./EquipmentTypeFunctions";
import type { IEquipmentDetails } from "./IEquipmentDetails";
import type { IEquipmentSlim } from "./IEquipmentSlim";

export class EquipmentFunctions {
    public static enhanceEquipment<T extends IEquipmentSlim>(eq: T): T {
        eq.type = EquipmentTypeFunctions.enhanceEquipmentType(eq.type);

        const eqDetails = eq as IEquipmentSlim as IEquipmentDetails;

        forEach(eqDetails.supportedCommunicationInterfaces, (v) => {
            v.typeName = v.type as any;
            v.type = CommunicationInterfaceType[v.typeName];
        });

        forEach(eqDetails.communicationConfigurations, (v) => {
            v.typeName = v.type as any;
            v.type = CommunicationInterfaceType[v.typeName];
        });

        forEach(eqDetails.credentials, (c) => {
            c.typeName = c.type as any;
            c.type = CredentialsType[c.typeName];
        });

        if (
            eqDetails.type !== undefined &&
            eqDetails.type !== null &&
            eqDetails.type.supportIpInterface !== undefined
        ) {
            eqDetails.supportIpConfigurations = some(
                eqDetails.supportedCommunicationInterfaces,
                (v) =>
                    v.type === CommunicationInterfaceType.WiredIP || v.type === CommunicationInterfaceType.WirelessIP,
            );
        }

        return eq;
    }

    public static updateEquipmentWithFunctionality(
        siteEquipment: ISiteEquipmentWithCoverages,
        functionalities: any,
    ): ISiteEquipmentWithCoverages {
        siteEquipment.functionalities = functionalities.filter(
            (functionality: any) => functionality.equipmentId === siteEquipment.id,
        );

        return siteEquipment;
    }
}
